import { agencyPath, createRequestWithComputedFilters } from '@/utils/api'
import network from '@/utils/network'

/**
 * Récupère les contrats customers
 * @param filters
 * @param opt
 * @returns {Promise}
 */
export const fetchAgencyCustomerContracts = createRequestWithComputedFilters(
  async (params) => {
    const r = await network.post(`${agencyPath()}/fetch/contracts/customers`, params)
    return r.data
  }, {
    orderBy: 'createdAt',
    filters: {
      status: [],
      end: '',
      start: ''
    }
  })

/**
 * Récupère le base64 d'un contrat client
 * @returns {Promise<>}
 */
export const getAgencyCustomerContractPdf = async (customerContractTemplate) => {
  const r = await network.post(`${agencyPath()}/contract/customer/preview`, customerContractTemplate)
  return r.data
}

/**
 * Récupère un contrat client
 * @returns {Promise<>}
 */
export const getAgencyCustomerContract = async (id) => {
  const r = await network.get(`${agencyPath()}/contract/customer/${id}`)
  return r.data.contract
}

/**
 * Créé / met à jour un contrat customer
 * @returns {Promise<>}
 */
export const postAgencyCustomerContract = async (customerContract) => {
  const r = await network.post(`${agencyPath()}/contract/customer`, customerContract)
  return r.data
}

/**
 * Créé / met à jour le token de signature d'un contrat agent
 * @returns {Promise<>}
 */
export const postAgencyCustomerContractSigningToken = async (customerContract) => {
  const r = await network.post(`${agencyPath()}/contract/customer/signature`, customerContract)
  return r.data
}

/**
 * Supprime un  contrat client
 * @returns {Promise<>}
 */
export const deleteAgencyCustomerContract = async (id) => {
  const r = await network.delete(`${agencyPath()}/contract/customer/${id}`)
  return r.data
}
